import { Typography } from 'antd';
import React from 'react';

const LENGTH_OF_CHARACTERS = 8;

interface Props {
  suffixCount?: number;
  tooltip?: React.ReactNode;
  width: string;
  children: string;
}

const EllipsisMiddle: React.FC<Props> = ({
  suffixCount = LENGTH_OF_CHARACTERS,
  tooltip,
  width,
  children,
}) => {
  const arrOfWords = children.trim().split(' ');
  const lastWordCount = arrOfWords[arrOfWords.length - 1].length;
  const actualSuffixCount =
    lastWordCount < suffixCount ? lastWordCount : suffixCount;

  const start = children.slice(0, children.length - actualSuffixCount);
  const suffix = children.slice(-actualSuffixCount);

  return (
    <Typography.Text ellipsis={{ suffix, tooltip }} style={{ width }}>
      {start}
    </Typography.Text>
  );
};

export { EllipsisMiddle };
